const messagingDestinations = {
    MESSENGER: ['Messenger'],
    WHATSAPP: ['WhatsApp'],
    INSTAGRAM_DIRECT: ['Instagram DMs'],
    MESSAGING_MESSENGER_WHATSAPP: ['Messenger', 'WhatsApp'],
    MESSAGING_INSTAGRAM_DIRECT_MESSENGER: ['Messenger', 'Instagram DMs'],
    MESSAGING_INSTAGRAM_DIRECT_MESSENGER_WHATSAPP: [
        'Messenger',
        'Instagram DMs',
        'WhatsApp',
    ],
};
export function getCampaignDestinationLabels(campaign) {
    // Before the WEBSITE check: a booking funnel's ad set is a WEBSITE one too.
    if (campaign.followUpType === 'booking_funnel')
        return ['Booking funnel'];
    if (campaign.followUpType === 'lead_form' ||
        campaign.destinationType === 'ON_AD')
        return ['Lead form'];
    if (campaign.followUpType === 'website' ||
        campaign.destinationType === 'WEBSITE')
        return ['Website'];
    const destinations = messagingDestinations[campaign.destinationType ?? ''];
    if (destinations)
        return destinations;
    switch (campaign.conversionDestination) {
        case 'messenger':
            return ['Messenger'];
        case 'whatsapp':
            return ['WhatsApp'];
        case 'instagram_direct':
            return ['Instagram DMs'];
        default:
            return campaign.followUpType === 'chatbot' ? ['Messaging'] : [];
    }
}
/** Results and their cost must use the same denominator, for every destination. */
export function getCampaignResultConfig(campaign) {
    // Pixel leads from the funnel's details step (the ad set optimises for them).
    if (campaign.followUpType === 'booking_funnel') {
        return {
            singular: 'lead',
            plural: 'leads',
            costUnit: 'lead',
            scale: 1,
            pick: (t) => t.leads,
        };
    }
    if (campaign.followUpType === 'lead_form' ||
        campaign.destinationType === 'ON_AD') {
        return {
            singular: 'submission',
            plural: 'submissions',
            costUnit: 'lead',
            scale: 1,
            pick: (t) => t.leads,
        };
    }
    if (campaign.followUpType === 'website' ||
        campaign.destinationType === 'WEBSITE')
        return linkClickResult;
    if (campaign.followUpType === 'chatbot' ||
        getCampaignDestinationLabels(campaign).length > 0) {
        return {
            singular: 'conversation',
            plural: 'conversations',
            costUnit: 'conversation',
            scale: 1,
            pick: (t) => t.messagingConversations,
        };
    }
    switch (campaign.objective) {
        case 'OUTCOME_LEADS':
            return {
                singular: 'lead',
                plural: 'leads',
                costUnit: 'lead',
                scale: 1,
                pick: (t) => t.leads,
            };
        case 'OUTCOME_SALES':
            return {
                singular: 'purchase',
                plural: 'purchases',
                costUnit: 'purchase',
                scale: 1,
                pick: (t) => t.conversions,
            };
        case 'OUTCOME_TRAFFIC':
            return linkClickResult;
        default:
            return {
                singular: 'impression',
                plural: 'impressions',
                costUnit: '1,000 impressions',
                scale: 1000,
                pick: (t) => t.impressions,
            };
    }
}
const linkClickResult = {
    singular: 'link click',
    plural: 'link clicks',
    costUnit: 'link click',
    scale: 1,
    pick: (t) => t.linkClicks,
};
//# sourceMappingURL=campaign-presentation.js.map